export const TWO_BUSINESS_DAYS = 2;
